import { render } from "./CampaignFunnel.vue?vue&type=template&id=0b6828c3&scoped=true"
import script from "./CampaignFunnel.vue?vue&type=script&lang=js"
export * from "./CampaignFunnel.vue?vue&type=script&lang=js"

import "./CampaignFunnel.vue?vue&type=style&index=0&id=0b6828c3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6828c3"]])

export default __exports__